import { DomainEvent } from '../types'

export const META_EVENT_NAMES: Partial<Record<DomainEvent, string>> = {
  page_view: 'PageView',
  view_item: 'ViewContent',
  view_item_list: 'ViewCategory',
  search: 'Search',
  add_to_cart: 'AddToCart',
  view_cart: 'ViewCart',
  begin_checkout: 'InitiateCheckout',
  add_payment_info: 'AddPaymentInfo',
  purchase: 'Purchase',
  add_to_wishlist: 'AddToWishlist',
  generate_lead: 'Contact',
  sign_up: 'CompleteRegistration',
  // remove_from_cart, login: no Meta counterpart
}

export const META_CUSTOM_EVENTS: ReadonlySet<DomainEvent> = new Set<DomainEvent>(['view_item_list'])
